import {FC} from 'react';
import MenuItem from '@mui/material/MenuItem';
import {NavLink} from 'react-router-dom';
import Typography from '@mui/material/Typography';
import cn from 'classnames';

import {IMenuItem} from '../../../../shared/types/menu.types';

import {colors} from '../../../../shared/colors';

import styles from './SidebarLink.module.scss';

interface ISidebarLink {
  item: IMenuItem;
  selected: boolean;
}

const SidebarLink: FC<ISidebarLink> = ({item: {Icon, title, link}, selected}) => {
  return (
    <NavLink
      draggable={false}
      to={link}
      className={({isActive}) => (isActive ? cn(styles.link, styles.active) : styles.link)}
    >
      <MenuItem selected={selected} key={title + link}>
        {Icon && <Icon sx={{color: colors['icons--primary']}} />}
        <Typography
          sx={{
            letterSpacing: '.5px',
            fontSize: '17px',
            fontWeight: 600,
            opacity: 0.85,
          }}
          color={colors['text--primary']}
          component="span"
        >
          {title}
        </Typography>
      </MenuItem>
    </NavLink>
  );
};

export default SidebarLink;
